@if (!ppShowHoursOnly) {
  <input
    #daysInput
    preventPointSwitching
    [ppAutonumeric]="autonumericOptions"
    class="pointCF__input pointCF__input--time"
    [class.disabled]="ppIsLocked || !ppCanEdit"
    [(ngModel)]="inputDays"
    placeholder="day"
    data-test="daysInput"
    [disabled]="ppIsLocked || !ppCanEdit"
    (ppFormatted)="updateDaysInput($event)"
    (keydown.enter)="blurInput($event)"
  />
}

<input
  #hoursInput
  preventPointSwitching
  [ppAutonumeric]="autonumericOptions"
  class="pointCF__input pointCF__input--time"
  [class.disabled]="ppIsLocked || !ppCanEdit"
  [(ngModel)]="inputHours"
  placeholder="hr"
  aria-label="hours"
  data-test="hoursInput"
  (ppFormatted)="updateHoursInput($event)"
  (keydown.enter)="blurInput($event)"
  [disabled]="ppIsLocked || !ppCanEdit"
/>

<input
  #minutesInput
  preventPointSwitching
  [ppAutonumeric]="autonumericOptions"
  class="pointCF__input pointCF__input--time"
  [class.disabled]="ppIsLocked || !ppCanEdit"
  [(ngModel)]="inputMinutes"
  placeholder="min"
  data-test="minsInput"
  (ppFormatted)="updateMinutesInput($event)"
  (keydown.enter)="blurInput($event)"
  [disabled]="ppIsLocked || !ppCanEdit"
/>
